<template>
    <v-container>
        <v-tabs
                slider-color="yellow" show-arrows>
            <v-tab>
                Matriz de procesos peligrosos
            </v-tab>
            <v-tab-item>
                <v-data-table
                        :headers="headersPeligroso"
                        :items="this.listProcesosPeligrosos"
                        class="elevation-1"
                        sort-icon="mdi-menu-down"
                        :search="search"
                >
                    <template slot="items" slot-scope="props">
                        <td class="text-xs-left" :style="getColor(props.item.value)">{{ props.item.companyJob.name }}
                        </td>
                        <td class="text-xs-left" :style="getColor(props.item.value)">{{ props.item.type.name }}</td>
                        <td class="text-xs-left" :style="getColor(props.item.value)">{{ props.item.element.name }}</td>
                        <td class="text-xs-left" :style="getColor(props.item.value)">{{ props.item.value }}</td>
                        <td class="text-xs-left" :style="getColor(props.item.value)">{{ props.item.date}}</td>
                    </template>
                    <v-alert slot="no-results" :value="true" color="error" icon="warning">
                        No se han encontrado resultados para "{{ search }}".
                    </v-alert>
                </v-data-table>
            </v-tab-item>
            <v-tab>
                Proessat
            </v-tab>
            <v-tab-item lazy>
                <proessat></proessat>
            </v-tab-item>
            <v-tab>
                Mediciones
            </v-tab>
            <v-tab-item lazy>
                <p class="font-weight-bold">Puesto de trabajo: {{measure.job!=null?measure.job.name:""}}</p>
                <p class="font-weight-bold">Agencia: {{measure.agency!=null?measure.agency.name:""}}</p>

                <v-data-table
                        :headers="headersMeasures"
                        :items="measure.jobMeasureDets"
                        class="elevation-1"
                        hide-actions
                >
                    <template slot="items" slot-scope="props">
                        <td class="text-xs-left">
                            <v-text-field
                                    name="value"
                                    label="Medición"
                                    id="val"
                                    :rules="[v => !!v || 'Es requerido',v => (v && v.length <= 550) || 'El número de caracteres debe ser menor a 500']"
                                    v-model="props.item.measure"
                                    required
                            ></v-text-field>
                        </td>
                        <td class="text-xs-left">
                            <v-text-field
                                    name="value"
                                    label="Valor"
                                    id="val"
                                    :rules="[v => !!v || 'Es requerido',v => (v && v.length <= 550) || 'El número de caracteres debe ser menor a 500']"
                                    v-model="props.item.value"
                                    required
                            ></v-text-field>
                        </td>

                        <td class="text-xs-left">
                            <v-text-field
                                    name="value"
                                    label="Unidad"
                                    id="val"
                                    :rules="[v => !!v || 'Es requerido',v => (v && v.length <= 550) || 'El número de caracteres debe ser menor a 500']"
                                    v-model="props.item.unit"
                                    required
                            ></v-text-field>
                        </td>
                    </template>
                    <v-alert slot="no-results" :value="true" color="error" icon="warning">
                        No se han encontrado resultados para "{{ search }}".
                    </v-alert>
                </v-data-table>
            </v-tab-item>
        </v-tabs>
    </v-container>
</template>
<script>

    import DangerousProcess from "../../../model/DangerousProcess";
    import Proessat from "../../patient/proessat/CuestionarioProessat";

    export default {
        props: ['company'],
        data() {
            return {
                radioGroup: 1,
                search: '',
                valid: false,
                valid2: false,
                requiredField: [v => !!v || 'Es requerido'],
                dialog: false,
                dialogDiagnostic: false,
                diagnostico: {nombre: "", clase: "", tipo: ""},
                dialogSuccess: false,
                editedIndex: -1,
                show: false,
                headers: [
                    {text: 'FECHA Y HORA', value: 'fecha'},
                    {text: 'NOTAS DE EVOLUCIÓN', value: 'notes'},
                    {text: 'FARMACOTERAPIA E INDICACIONES', value: 'group'},
                    {text: 'DIAGNOSTICO', value: 'group'},
                    {text: 'ACCIONES', value: 'actions'},

                ],
                listProcesosPeligrosos: [],
                itemsPeligrosos: ['1', '2', '3', '4', '5', '6', '7', '8', '9'],
                peligroso: new DangerousProcess(),
                peligrosos: [],
                itemsElements: [],
                headersPeligroso: [
                    {text: 'Puesto de trabajo', value: 'code'},
                    {text: 'Tipo', value: 'type'},
                    {text: 'Elemento', value: 'element'},
                    {text: 'Valor', value: 'value'},
                    {text: 'Fecha', value: 'date'},
                ],
                headersMeasures: [
                    {text: 'Tipo de Medición', value: 'measure'},
                    {text: 'Valor', value: 'value'},
                    {text: 'Unidad', value: 'unit'}
                ],
                measure: ""


            };
        },
        methods: {
            cleanData() {
            },


            getFormattedDate(dateReg) {
                var ua = navigator.userAgent.toLowerCase();
                var date;
                if (ua.indexOf('safari') != -1) {
                    if (ua.indexOf('chrome') > -1) {
                        // Para chrome
                        date = new Date(dateReg);
                    } else {
                        // Para Safari
                        if (!(dateReg instanceof Date)) {
                            var b = dateReg.toString().split(/\D/);
                            date = new Date(Date.UTC(b[0], --b[1], b[2], b[3], b[4], b[5]));
                        } else {
                            date = new Date(dateReg);
                        }
                    }
                } else {
                    // Otros navegadores
                    date = new Date(dateReg);
                }
                var month = date.getMonth() + 1;
                var day = date.getDate();
                var hour = date.getHours();
                var min = date.getMinutes();
                var sec = date.getSeconds();
                month = (month < 10 ? "0" : "") + month;
                day = (day < 10 ? "0" : "") + day;
                hour = (hour < 10 ? "0" : "") + hour;
                min = (min < 10 ? "0" : "") + min;
                sec = (sec < 10 ? "0" : "") + sec;
                var str = date.getFullYear() + "-" + month + "-" + day + " " + hour + ":" + min + ":" + sec;
                return str;
            },

            getColor(item) {
                if (item == "1" || item == "2" || item == "3") {
                    return "background-color: greenyellow"
                } else if (item == "4" || item == "5" || item == "6") {
                    return "background-color: #FFA420"
                } else {
                    return "background-color: red"
                }
            },

            reloadData() {
                this.$store.dispatch('getDangerousProcess', this.$store.state.patient.company.id).then(
                    response => {
                        for (let i = 0; i < this.$store.state.dangerousProcesses.length; i++) {
                            if (this.$store.state.patient.jobCompany.toLowerCase() === this.$store.state.dangerousProcesses[i].companyJob.name.toLowerCase()) {
                                this.listProcesosPeligrosos.push(this.$store.state.dangerousProcesses[i])
                            }
                        }
                    },
                    error => {
                        this.$store.state.dialogError = true;
                    }
                );

                this.$store.dispatch('getCompanyJobsByCompany', this.$store.state.patient.company.id).then(
                    response => {
                        for (let i = 0; i < this.$store.state.companyJobs.length; i++) {
                            if (this.$store.state.patient.jobCompany.toLowerCase() === this.$store.state.companyJobs[i].name.toLowerCase()) {
                                for (let j = 0; j < this.$store.state.companyJobs[i].jobMeasures.length; j++) {
                                    if (this.$store.state.patient.agencyCompany.toLowerCase() === this.$store.state.companyJobs[i].jobMeasures[j].agency.name.toLowerCase()) {
                                        this.measure = this.$store.state.companyJobs[i].jobMeasures[j]
                                        break;
                                    }
                                }
                            }
                        }
                    },
                    error => {
                        this.$store.state.dialogError = true;
                    }
                )
            },


        },
        computed: {},
        created() {
            this.reloadData()
        },
        components: {
            Proessat

        }
    };
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/patient/condicionTrabajo/CondicionTrabajo.vue